import React from 'react'

import tokens from '@cinch/oxd-utils/tokens/src'
import { Text } from '@cinch-labs/design-system'

import * as styles from './hero.module.css'

export interface HeroImage {
  large: any
  small: any
  alt?: string
}

interface HeroProps {
  heading: string
  content?: any
  heroImage: HeroImage
}

const Hero: React.FC<HeroProps> = ({ heading, content, heroImage }) => {
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <Text element="h1" fontWeight="bold" fontSize="l" lineHeight="display" className={styles.heading}>
          {heading}
        </Text>
        {content && (
          <Text element="h2" fontWeight="book" fontSize="s" lineHeight="body" className={styles.description}>
            {content}
          </Text>
        )}
      </div>

      <div className={styles.imageContainer}>
        <picture>
          <source srcSet={heroImage.small.webp} media={tokens.customMedia.xxs} type="image/webp" />
          <source srcSet={heroImage.small.png} media={tokens.customMedia.xxs} type="image/png" />
          <source srcSet={heroImage.large.webp} media={tokens.customMedia.m} type="image/webp" />
          <source srcSet={heroImage.large.png} media={tokens.customMedia.m} type="image/png" />
          <img className={styles.image} alt={heroImage.alt} src={heroImage.large.png} />
        </picture>
      </div>
    </div>
  )
}

export default Hero
